export default function hrefFromQuery(pathname: string, query: object): string {
  return `${pathname}?${Object.keys(query)
    .map(key => {
      return `${key}=${query[key]}`;
    })
    .join('&')}`;
}
